/**
 * Apps Chooser Guard
 *
 * Frappe's app-chooser page (frappe/www/apps.html, served at /apps) is the
 * screen a user with more than one "app" sees on login, where they pick e.g.
 * Desktop vs SGC Mobile. When a tile is clicked, core asks the server where to
 * go and then navigates there with NO fallback:
 *
 *     window.location.href = r.message;
 *
 * If that value comes back empty/undefined the browser navigates to the literal
 * path "/undefined" and the user hits a 404 on first login. (Deleting
 * "undefined" from the address bar lets them continue, and the browser then has
 * enough saved state that it never recurs — which is why it looks first-login
 * only.) Confirmed on production 2026-08: 13 of 14 "/undefined" hits refer from
 * "/apps".
 *
 * apps.html is Frappe core and must not be edited — a core patch is wiped by the
 * next frappe pull — so this guard is injected onto portal pages via
 * web_include_js instead. It does two independent things:
 *
 *   1. RepairChooser — on /apps, re-binds the tile click with a safe fallback so
 *      an empty server answer can never produce "/undefined": it falls back to
 *      the tile's own route, then to the desk.
 *   2. CatchBrokenLanding — on /undefined, bounces the user to the desk, as a
 *      final safety net for any path this guard did not cover.
 *
 * Pairs with apps_switcher_override.bundle.js, which handles the separate DESK
 * app-switcher (frappe.ui.AppsSwitcher), not this login-time chooser page.
 */
(function () {
	"use strict";

	var DESK_FALLBACK = "/app";
	var CHOOSER_PATH = "/apps";
	var BROKEN_PATH = "/undefined";

	// A destination is unusable if it is genuinely empty, or is one of the
	// strings an absent value stringifies to. localStorage and the server
	// round-trip both coerce a real "undefined"/None into that literal text, so
	// guard the strings as well as the empty case.
	function IsBadRoute(route) {
		return (
			!route ||
			route === "undefined" ||
			route === "null" ||
			route === "None" ||
			route === BROKEN_PATH
		);
	}



	// The user already landed on /undefined. Send them to the desk rather than
	// leave them on a 404. Runs immediately so the 404 is never really seen.
	function CatchBrokenLanding() {
		if (window.location.pathname !== BROKEN_PATH) {
			return;
		}

		window.location.replace(DESK_FALLBACK);
	}



	// Replace core's tile handler with one that falls back to the tile's own
	// route, then the desk, whenever the server answer is empty. Runs on DOM
	// ready, which is after core's inline script has bound its own handler, so
	// the .off("click") below removes exactly that handler and nothing else.
	function RepairChooser() {
		if (window.location.pathname !== CHOOSER_PATH) {
			return;
		}

		$(".app-name-cls")
			.off("click")
			.on("click", function () {
				var appName = $(this).attr("app-name") || "";
				var appRoute = $(this).attr("app-route") || "";
				var safeRoute = IsBadRoute(appRoute) ? DESK_FALLBACK : appRoute;

				localStorage.current_app = appName;
				localStorage.current_route = appRoute;

				frappe.call({
					method: "frappe.apps.get_incomplete_setup_route",
					args: { current_app: appName, app_route: appRoute },
					callback: function (response) {
						var destination = response && response.message;
						window.location.href = IsBadRoute(destination) ? safeRoute : destination;
					},
					error: function () {
						window.location.href = safeRoute;
					},
				});
			});
	}

	CatchBrokenLanding();
	$(RepairChooser);
})();
